export function phoneFieldsAreValid(fields) {
  if (!fields) return true;

  return (Array.isArray(fields) ? fields : [fields])
    .every((field) => typeof field.validate !== "function" || field.validate());
}
